<template>
    <div class="navbar">
        <van-nav-bar 
        fixed
        :title='title'
        left-arrow
        @click-left="onClickLeft"
        @click-right="onClickRight"
        />    
        <div class="kong"></div>
    </div>

</template>

<script>
import Vue from 'vue';
import { NavBar } from 'vant';

Vue.use(NavBar);
export default {
  props:['title'],
  data(){
    return{
    }
  },
  mounted(){
  },
  methods: {
    onClickLeft () {
      this.$router.go(-1)
    },
    onClickRight () {
    }
  }
}
</script>

<style>
.van-nav-bar__text{
    color: #000 !important;
}
.van-nav-bar .van-icon{
    color: #000 !important;
}
.van-hairline--top-bottom::after, .van-hairline-unset--top-bottom::after {
    border-width: none !important;
}
</style>

<style scoped>
.kong{
  width: 100%;
  height: 46px;
}
@media screen and (min-width: 800px) {
  .van-nav-bar--fixed {
      position: fixed;
      top: 0;
      right: 0;
      width: 800PX;
  }
}
@media screen and (min-width: 320px) and (max-width: 799px) {
  .van-nav-bar--fixed {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Navbar.vue